import React from 'react';

import { Field } from 'react-final-form';

import { Select } from '@change/ds-forms';

import { translationKey } from '@change-corgi/core/i18n';
import { useI18n } from '@change-corgi/core-react/i18n';

import { useFormI18n } from '#src/app/shared/form/hooks';
import { requiredValidator } from '#src/app/shared/form/validators';

import { usePetitionReportAbuseContext } from '../../shared/context';
import type { FormValues } from '../../shared/types';

import { useCountryField } from './hooks/useCountryField';

const validator = requiredValidator({
	i18n: { key: translationKey('corgi.policy_abuse.generic.errors.country_required') },
});

export const CountryField: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	const { getErrorMessage } = useFormI18n();
	const { countries } = usePetitionReportAbuseContext();

	const {
		data: { countries: countryList, initialValue },
	} = useCountryField(countries);

	const countryItems = [
		{ id: '', name: '', label: translate('corgi.policy_abuse.generic.country.prompt') },
		...countryList.map(({ countryCode, displayName }) => ({ id: countryCode, name: countryCode, label: displayName })),
	];

	return (
		<div>
			<Field<FormValues['country']> name="country" validate={validator} initialValue={initialValue}>
				{({ input, meta }) => (
					<Select
						className="[&_button_span]:text-typography-weak"
						name={input.name}
						selectedKey={input.value}
						onSelectionChange={input.onChange}
						// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
						errorMessage={meta.touched && getErrorMessage(meta.error)}
						data-testid="reportAbuse-country-select"
						data-qa="reportAbuse-country-select"
						label={translate('corgi.policy_abuse.generic.country.label')}
						items={countryItems}
						isInvalid={meta.touched && !!meta.error}
					/>
				)}
			</Field>
		</div>
	);
};
